import { BRAND_NAME, language } from "@chef/constants";

export const brand = (
  {
    AMK: {
      TITLE: "Smakelig måltid!",
    },
    GL: {
      TITLE: "God middag!",
    },
    LMK: {
      TITLE: "Smaklig måltid!",
    },
    RN: {
      TITLE: "Værsgo!",
    },
  } as const
)[BRAND_NAME];

export const intl = (
  {
    no: {
      BACK_TO_OVERVIEW: "Tilbake til oversikt",
      RECEIPT: "Kvittering",
      PICK_DISHES_FOR_NEXT_WEEK_BUTTON: (nextWeek: number) =>
        `Velg retter til uke ${nextWeek}`,
      PICK_DISHES_FOR_NEXT_WEEK_HEADER:
        "Planlegg neste uke allerede nå for å sikre familiens favoritter!",
      TO: "til",
      LAST_CHANCE: "Legg til noe ekstra?",
      WITHOUT_RECIPE_SHEET_THANKS_FOR_THINKING_ABOUT_THE_ENVIRONMENT:
        "Du har valgt bort printede oppskrifter. Takk for at du tenker på miljøet!",
      SHOW_MORE: "Vis mer",
      YOUR_ORDER_WILL_BE_DELIVERED: "Leveres",
      QUESTIONS: "Spørsmål?",
      CONTACT_CUSTOMER_SERVICE_HERE: "Kontakt kundeservice her.",
    },

    se: {
      HEADER: "Bon Appétit!",
      BACK_TO_OVERVIEW: "Tillbaka till min meny",
      RECEIPT: "Kvitto",
      PICK_DISHES_FOR_NEXT_WEEK_BUTTON: (nextWeek: number) =>
        `Planera v.${nextWeek}`,
      PICK_DISHES_FOR_NEXT_WEEK_HEADER:
        "Planera nästa veckas meny nu för att säkra familjens favoriter!",
      TO: "till",
      LAST_CHANCE: "Lägg till något extra?",
      WITHOUT_RECIPE_SHEET_THANKS_FOR_THINKING_ABOUT_THE_ENVIRONMENT:
        "Utan receptblad, tack för att du tänker på miljön!",
      SHOW_MORE: "Visa mer",
      YOUR_ORDER_WILL_BE_DELIVERED: "Levereras",
      QUESTIONS: "Frågor?",
      CONTACT_CUSTOMER_SERVICE_HERE: "Kontakta kundtjänst här.",
    },

    dk: {
      HEADER: "Bon Appétit!",
      BACK_TO_OVERVIEW: "Tilbage til oversigt",
      RECEIPT: "Kvittering",
      PICK_DISHES_FOR_NEXT_WEEK_BUTTON: (nextWeek: number) =>
        `Vælg retter til uge ${nextWeek}`,
      PICK_DISHES_FOR_NEXT_WEEK_HEADER:
        "Planlæg næste uge allerede nu for at sikre dine favoritter!",
      TO: "til",
      LAST_CHANCE: "Tilføj noget ekstra?",
      WITHOUT_RECIPE_SHEET_THANKS_FOR_THINKING_ABOUT_THE_ENVIRONMENT:
        "Du har fravalgt printede opskrifter. Tak, fordi du tænker på miljøet!",
      SHOW_MORE: "Vis mere",
      YOUR_ORDER_WILL_BE_DELIVERED: "Leveres",
      QUESTIONS: "Spørgsmål?",
      CONTACT_CUSTOMER_SERVICE_HERE: "Kontakt kundeservice her.",
    },
  } as const
)[language];
